import BillReviewDetailsNew from '../../../bills/components/discovery/BillReviewDetailsNew';

export default function EditReviewBillScreen() {
    return <BillReviewDetailsNew />;
}
